import { useQuery } from "@tanstack/react-query";
import { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import toast from "react-hot-toast";

import UserSearchForm from "../../../../components/Users/UserSearchForm";
import { UserContext } from "../../../../Context/UserContextAPI";
import Loading from "../../../../utils/Loader/Loading";
import request from "../../../../utils/request";
import { format } from "date-fns";

const CombineMedicalPathologyPrint = () => {
  const { currentUser, settingsData } = useContext(UserContext);

  const [filterData, setFilterData] = useState({
    fromDate: new Date().toISOString().split("T")[0],
    toDate: new Date().toISOString().split("T")[0],
  });

  const { data, isPending: isLoadingUsers } = useQuery({
    queryKey: ["users", "pathology", filterData],
    queryFn: async () => {
      const query = new URLSearchParams(filterData).toString();
      const response = await request.getAll(
        `v2/reports/results/users/pathology?${query}`,
      );

      if (response.status !== "OK") {
        toast.error("Server error occurred.");
      }

      return response.data || [];
    },
  });

  const userData = data?.users || [];
  const pathologyInvestigation = data?.investigation;

  const userStatus = (status) => {
    if (status === 1) {
      return ` PROCESSING`;
    } else if (status === 2) {
      return ` FIT`;
    } else if (status === 3) {
      return ` UNFIT`;
    } else if (status === 4) {
      return ` HELD UP`;
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <section className="card medical-report-container print-area-landscape">
      {/* <div className="row align-items-center">
        <img
          src={`${process.env.REACT_APP_UPLOAD_URL}/${settingsData?.header_image}`}
          alt="Report Header"
          className="mx-auto"
          style={{
            width: "100%",
          }}
        />
      </div> */}
      <div className="card-body">
        <div className="border p-3 rounded mb-3  print-hidden">
          <h6 className="btn btn-danger text-white fw-bold">
            Combine Medical Pathology
          </h6>

          <UserSearchForm
            userSearchHandler={(val) => setFilterData(val)}
            inlineButtonComponent={
              <>
                <Button onClick={handlePrint}>Print</Button>
                <Button variant="danger" onClick={() => window.close()}>
                  Close
                </Button>
              </>
            }
          />
        </div>
        <div>
          <h2 className="text-center fs-2 my-3">
            {settingsData?.website_name}{" "}
          </h2>
          <h2 className="text-center fs-2 my-3">Pathology Test Report</h2>

          <h2 className="text-center fs-2 my-3">
            Date: {format(new Date(filterData?.fromDate), "dd/MM/yyyy")}
            {filterData?.fromDate !== filterData?.toDate && (
              <span className="text-center fs-2 my-3">
                {" "}
                to {format(new Date(filterData?.toDate), "dd/MM/yyyy")}
              </span>
            )}
          </h2>
        </div>

        {isLoadingUsers ? (
          <Loading />
        ) : (
          <div>
            <Table
              striped
              bordered
              // hover
              // responsive
              // className="combine-pathology-table"
            >
              <thead style={{ color: "black" }}>
                <tr>
                  <th>Srl</th>
                  <th>Registration No</th>

                  <th>Name</th>
                  {pathologyInvestigation.map((inv) => (
                    <th key={inv.id}>{inv.name}</th>
                  ))}

                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>

              <tbody>
                {userData.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.reg_prefix + user.registration_no}</td>
                    <td>{user.f_name}</td>
                    {pathologyInvestigation.map((investigation) => {
                      const isMaleAndPregnancyTest =
                        (user.userDetail?.gender?.name === "Male" ||
                          user.userDetail?.gender?.name === "male" ||
                          user.userDetail?.gender_id === 1) &&
                        investigation?.name === "Pregnancy Test";

                      if (isMaleAndPregnancyTest) {
                        return <td key={investigation.id}>-</td>;
                      }
                      const reports = user.tests.find(
                        (test) => test.investigation_id === investigation.id,
                      );

                      return (
                        <td key={investigation.id}>
                          {reports ? reports.result : "-"}
                        </td>
                      );
                    })}
                    <td>{userStatus(user.status)}</td>
                    <td>{user.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </section>
  );
};

export default CombineMedicalPathologyPrint;
